<script>
  import Container from "#lib/Container.svelte";
  let { entry } = $props();
</script>

<div class="page-entry">
  <!-- with bind:this we link the model with the component instance -->
  <Container
    container={entry.body}
    bind:this={entry.body.ref}
  />
</div>